import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function useAnalytics() {
  const location = useLocation();
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const path = location.pathname + location.search;
    if (window.fbq) window.fbq("track", "PageView");
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location.pathname, location.search]);
}
